import { Fragment, useEffect, useRef, useState } from "react";
import { fetchSocialMensajesHilo } from "../../../api";
import type { SocialMensajesHilo } from "../../../types";
import { MESES_LARGO } from "./mensajesUtil";

const dia = (iso: string | null) => {
  if (!iso) return "";
  const d = new Date(new Date(iso).toLocaleString("en-US", { timeZone: "America/Santiago" }));
  return `${d.getDate()} de ${MESES_LARGO[d.getMonth()]} de ${d.getFullYear()}`;
};
const hora = (iso: string | null) =>
  iso ? new Date(iso).toLocaleTimeString("es-CL", { timeZone: "America/Santiago", hour: "2-digit", minute: "2-digit", hour12: false }) : "";

/** Conversación completa como burbujas: el cliente a la izquierda, la página a la derecha. */
export function HiloConversacion({ clientSlug, platform, conversationId }: { clientSlug: string; platform: string; conversationId: string }) {
  const [hilo, setHilo] = useState<SocialMensajesHilo | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [intento, setIntento] = useState(0);
  const fin = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let activo = true;
    setHilo(null);
    setError(null);
    fetchSocialMensajesHilo(clientSlug, platform, conversationId)
      .then((r) => activo && setHilo(r))
      .catch((e: unknown) => activo && setError(e instanceof Error ? e.message : "Error desconocido"));
    return () => {
      activo = false;
    };
  }, [clientSlug, platform, conversationId, intento]);

  useEffect(() => {
    if (hilo) fin.current?.scrollIntoView({ block: "nearest" });
  }, [hilo]);

  if (error)
    return (
      <div className="msj-hilo-estado" role="alert">
        <p>No se pudo cargar la conversación: {error}</p>
        <button type="button" className="msj-btn" onClick={() => setIntento((x) => x + 1)}>Reintentar</button>
      </div>
    );
  if (!hilo)
    return (
      <div className="msj-hilo-estado" role="status">
        <p>Cargando conversación…</p>
      </div>
    );

  let ultimoDia = "";
  return (
    <div className="msj-hilo" role="log" aria-label="Conversación">
      {hilo.mensajes.map((m) => {
        const d = dia(m.created_time);
        const separador = d !== ultimoDia;
        ultimoDia = d;
        const salida = m.sender_role === "page";
        return (
          <Fragment key={m.message_id}>
            {separador && <div className="msj-day">{d}</div>}
            <div className={`msj-msg ${salida ? "out" : "in"}`}>
              <div className="msj-bub">{m.message_text?.trim() || "Sin texto"}</div>
              <div className="msj-meta num">{salida ? "Página" : "Cliente"} · {hora(m.created_time)}</div>
            </div>
          </Fragment>
        );
      })}
      {hilo.truncado && <p className="msj-day">Se muestran los primeros {hilo.mensajes.length} mensajes.</p>}
      <div ref={fin} />
    </div>
  );
}
